import { IUser } from '@gig/magic-sdk/dist/adapter/users/user';
import { magic } from '@gig/magic-sdk';

export class ZendeskBase {
    protected user: IUser | null | undefined = null;

    updateUserData(user?: IUser | null) {
        this.user = user;
    }

    prePopulateChatFields() {
        this.updateUserData(magic.session.getUser());
        const { firstName, lastName, email } = this.user || {
            firstName: '',
            lastName: '',
            email: '',
        };
        if (this.user) {
            window.zE?.('webWidget', 'identify', {
                name: `${firstName}` + (lastName ? ` ${lastName}` : ''),
                email,
            });
        }
    }
}
